import { createAsyncThunk } from '@reduxjs/toolkit';
import { getUserVehicles } from '../../lib/userVehicles';

export const fetchUserVehicles = createAsyncThunk(
  'vehicles/fetchUserVehicles',
  async ({ userId, pagination, options = {} }) => {
    const data = await getUserVehicles(userId, pagination, options);

    return data;
  }
);